import { render, staticRenderFns } from "./MStoreFormTextarea.vue?vue&type=template&id=30a5f3de&"
import script from "./MStoreFormTextarea.vue?vue&type=script&lang=ts&"
export * from "./MStoreFormTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports